export default "__VITE_ASSET__42d26bd3__"